import Component from "@glimmer/component";
import dIcon from "discourse/ui-kit/helpers/d-icon";
import dNumber from "discourse/ui-kit/helpers/d-number";
import { i18n } from "discourse-i18n";
import { i18nForOwner } from "discourse/plugins/discourse-rewind/discourse/lib/rewind-i18n";

export default class FavoriteGifs extends Component {
  get favoriteGifs() {
    return this.args.report.data.favorite_gifs ?? [];
  }

  get titleText() {
    return i18nForOwner(
      "discourse_rewind.reports.favorite_gifs.title",
      this.args.isOwnRewind,
      { count: this.favoriteGifs.length, username: this.args.user?.username }
    );
  }

  <template>
    {{#if this.favoriteGifs.length}}
      <div class="rewind-report-page --favorite-gifs">
        <h2 class="rewind-report-title">{{this.titleText}}</h2>
        <div class="rewind-report-subtitle">{{i18n
            "discourse_rewind.reports.favorite_gifs.total_usage"
            count=@report.data.total_gif_usage
          }}</div>
        <div class="rewind-report-container">
          {{#each this.favoriteGifs as |gif idx|}}
            <div class="rewind-card scale">
              <div class="favorite-gifs__gif">
                <img
                  alt="GIF #{{idx}}"
                  class="favorite-gifs__image"
                  loading="lazy"
                  src={{gif.url}}
                />
                <div class="favorite-gifs__stats">
                  <span class="favorite-gifs__stat">
                    {{dIcon "repeat"}}
                    {{dNumber gif.usage_count}}
                  </span>
                  <span class="favorite-gifs__stat">
                    {{dIcon "heart"}}
                    {{dNumber gif.likes}}
                  </span>
                  <span class="favorite-gifs__stat">
                    {{dIcon "smile"}}
                    {{dNumber gif.reactions}}
                  </span>
                </div>
              </div>
            </div>
          {{/each}}
        </div>
      </div>
    {{/if}}
  </template>
}
